const u = (a) => {
  const r = {};
  return Array.isArray(a) && a.forEach((t) => {
    if (t && typeof t == "object" && "data" in t && "value" in t) {
      const e = t;
      r[e.data] = e.value;
    }
  }), r;
};
export {
  u as default
};
